import styled from 'styled-components';
import React from 'react';

const TimeDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: gray;
  margin-bottom: 0.6rem;
  time {
    font-size: 0.95rem;
    @media (max-width: 700px) {
      font-size: 0.8rem;
    }
  }
  span {
    @media (max-width: 700px) {
      font-size: 1rem;
    }
  }
`;

export default ({ date }) => (
  <TimeDiv>
    <span className="material-icons">calendar_today</span>&nbsp;
    <time>{date}</time>
  </TimeDiv>
);



// WEBPACK FOOTER //
// ./src/components/Date.js